import { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { Button, Card, Input, Popover, Tag, Typography } from 'antd'
import { Check, Edit, Move, Plus, X } from 'react-feather'
import { QuestionCircleOutlined } from '@ant-design/icons'
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd"
import { setMemberKeys } from 'Actions/explore'
import { getNamespaceLabel, getNamespaceValue } from 'Services/WeaverUtils'
import { MemberKeys, DisabledRelations } from 'Model'
import WeaverService from 'Services/WeaverService'
import { forceCompliancy } from 'Services/SparqlComplianceService'
import './NameKeysPanel.scss'
{ Paragraph, Text } = Typography

helpText = (<div style={{ width: 500, lineHeight: '1.6rem' }}>
  <Paragraph>
    The member key is used to determine the <Text mark>type</Text> of elements within a project.
    If an element is type <Text code>Person</Text>, it means that the element has a <Text code>memberKey</Text> relation to the <Text code>Person</Text> type node.
  </Paragraph>
  <Text type="secondary">
    Note: Changing this will not actually update anything in the database, just how the app reads from the database.
    So, if you change this just to explore, and then later change it back, the data and app views will look the same as they did previously.
  </Text>
</div>)

info = (
  <Popover
    content={helpText}
    title='Member Key'
    trigger="click"
    placement="left"
  >
    <a><QuestionCircleOutlined /></a>
  </Popover>
)

MemberKeysPanel = ({ memberKeys, setMemberKeys }) ->

  [isEditing, setIsEditing] = useState(false)
  [node, setNode] = useState(undefined)
  [dataArray, setDataArray] = useState(memberKeys)
  [loading, setLoading] = useState(true)
  [newKey, setNewKey] = useState(undefined)
  [error, setError] = useState(undefined)

  grid = 8

  useEffect( ->
    ( ->
      node = await MemberKeys.load()
      setNode(node)
      setLoading(false)
    )()
    undefined
  , [])

  reorder = (list, startIndex, endIndex) ->
    result = Array.from(list)
    [removed] = result.splice(startIndex, 1)
    result.splice(endIndex, 0, removed)
    result

  getListStyle = (isDraggingOver) -> {
    padding: grid,
    width: '100%'
  }

  getItemStyle = (isDragging, draggableStyle) -> {
    userSelect: "text",
    margin: "0 0 #{ grid }px 0",
    border: "1px solid",
    padding: 10,
    borderRadius: 3,
    borderColor: isDragging && "#58bd91" || "transparent",
    display: 'block',
    ...draggableStyle
  }

  onDragEnd = (result) ->
    return unless result.destination
    newData = reorder(
      dataArray,
      result.source.index,
      result.destination.index
    )
    setDataArray(newData)

  addMemberKey = ->
    respectNamespace = dataArray.map((item) -> getNamespaceValue(item))
    await node.update(respectNamespace)
    setMemberKeys(respectNamespace)

  actions = (
    if isEditing
      [
        <Button
          type="text"
          onClick={ ->
            await addMemberKey()
            setIsEditing(false)
          }
        >
          <Check />
        </Button>
        <Button
          type="text"
          onClick={ ->
            setDataArray(node.list())
            setIsEditing(false)
          }
        >
          <X />
        </Button>
      ]
    else
      [
        <Button
          type="text"
          disabled={!WeaverService.userCanEdit()}
          onClick={ -> setIsEditing(true)}
        >
          <Edit />
        </Button>
      ]
  )

  <Card
    title="Member Keys"
    actions={actions}
    extra={info}
    size="small"
    id="Member keys"
    loading={loading}
  >
    <DragDropContext onDragEnd={onDragEnd}>
      <Droppable droppableId="droppable">
        { (provided, snapshot) => (
          <div
            {...provided.droppableProps}
            ref={provided.innerRef}
            style={getListStyle(snapshot.isDraggingOver)}
          >
            {dataArray.map((item, index) => (
              <Draggable
                key={item}
                draggableId={item}
                index={index}
                isDragDisabled={!isEditing}
              >
                { (provided, snapshot) => (
                  <div
                    ref={provided.innerRef}
                    {...provided.draggableProps}
                    {...provided.dragHandleProps}
                    style={getItemStyle(
                      snapshot.isDragging,
                      provided.draggableProps.style
                    )}
                    className="name-key-item #{ if isEditing then 'is-dragging' else '' }"
                  >
                    <span>
                      <Move className="drag-handle-icon #{ if isEditing then 'is-dragging' else '' }" />
                      { getNamespaceLabel(item) }
                      <X
                        className="remove-item #{ if isEditing then 'is-dragging' else '' }"
                        onClick={ -> setDataArray(dataArray.filter((_item) -> _item isnt item))}
                      />
                    </span>
                  </div>
                ) }
              </Draggable>
            )) }
            { provided.placeholder }
            { if isEditing
              <div>
                <Input
                  value={newKey}
                  onChange={({ target: { value }}) ->
                    setError(undefined)
                    setNewKey(
                      forceCompliancy(value)
                    )
                  }
                  style={{ width: '66%' }}
                  placeholder="New member key"
                />
                <Button
                  icon={<Plus style={{ height: 16, position: 'relative', top: 3 }} />}
                  type="primary"
                  style={{ marginLeft: 20 }}
                  onClick={ ->
                    return setError('There is already a key with that value.') if dataArray.indexOf(newKey) > -1
                    setDataArray([dataArray..., newKey])
                    setNewKey(undefined)
                  }
                >Add</Button>
                <Text type="danger" style={{ marginLeft: 5 }}>{ error }</Text>
              </div>
            }
          </div>
        )}
      </Droppable>
    </DragDropContext>
  </Card>

export default connect(({ explore }) ->
  { memberKeys: explore.memberKeys }
, { setMemberKeys })(MemberKeysPanel)
